module.exports = __webpack_public_path__ + "fonts/IQOS-Bold.cace321.woff2";